import { useState } from "preact/hooks";
import classnames from "classnames";

import IconArrowNarrowUp from "tabler-icons/arrow-narrow-up.tsx";

interface CollapsibleCardProps {
  title: string, description: string, image: string,
}

export function CollapsibleCard({ title, description, image }: CollapsibleCardProps) {
  const [open, setOpen] = useState(false)

  return <div class="collapsible-card">
    <img src={image} alt={title} />
    <div className={classnames("cover", open && "open")} />
    <div className={classnames("content", open && "open")}>
      <div className="header">

        <h3>{title}</h3>
        <button type="button" class={classnames(open && "open")} onClick={() => setOpen(!open)}>
          <IconArrowNarrowUp />
        </button>
      </div>
      <p>{description}</p>
    </div>
  </div>
}